import script from "./VSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./VSwitch.vue?vue&type=script&setup=true&lang=js"

import "./VSwitch.vue?vue&type=style&index=0&id=4307e562&lang=scss"

const __exports__ = script;

export default __exports__